// Add project specific javascript code and import of additional bundles here:
import {formToolbarActionRegistry} from 'sulu-admin-bundle/views';
import ExportAddressDocumentToolbarAction from './toolbarActions/ExportAddressDocumentToolbarAction';

formToolbarActionRegistry.add('app.export_address_document', ExportAddressDocumentToolbarAction);
